module.exports = __webpack_public_path__ + "img/info_platform.be7db50.png";